import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DefaultLayout } from "../../layouts/Default";
import { Main } from "../../themes/Default/components/Main";
import { Title } from "../../themes/Default/components/Title";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../themes/Default/components/List";
import { Header as ListHeader } from "../../themes/Default/components/List/components/Header";
import { Body as ListBody } from "../../themes/Default/components/List/components/Body";
import { TableHead } from "../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Menu as ListMenu } from "../../themes/Default/components/List/components/Header/components/Menu";
import { Filter as ListFilter } from "../../themes/Default/components/List/components/Header/components/Filter";
import { Button as ListMenuButton } from "../../themes/Default/components/List/components/Header/components/Menu/components/Button";
import { studentsManagement } from "../../hooks/api/StudentsManagement";
import { useTranslation } from "react-i18next";
import { Input } from "../../themes/Default/components/Form/components/Input";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Form } from "../../themes/Default/components/Form";
import { Formik } from "formik";
import { getNumberOfUsedFilters } from "../../services/utils/Filter";
import DatePicker from "../../themes/Default/components/Form/components/DatePicker/DatePicker";
import { Select } from "../../themes/Default/components/Form/components/Select";
import { prepareSelect } from "../../services/core/Select";
import { languageProgramsManagement } from "../../hooks/api/LanguageProgramsManagement";
import { roles } from "../../services/utils/Roles";
import { useUserToken } from "../../hooks/core/UserToken";
import TimePicker from "../../themes/Default/components/Form/components/TimePicker/TimePicker";
import { locationsManagement } from "../../hooks/api/LocationsManagement";
import { languagesManagement } from "../../hooks/api/LanguagesManagement";
import { employeesManagement } from "../../hooks/api/EmployeesManagement";
import { settingsCallManagement } from "../../hooks/api/SettingsCallManagement";
import { Pagination } from "../../themes/Default/components/List/components/Footer/components/Pagination";
import { usePersistentFilters } from "../../hooks/core/PersistentFilters";

const TestsForProfessor = () => {
    const { t } = useTranslation("common");
    const recordsPerPage = 50;
    const defaultFilters = {
        startPage: 0,
        limitPage: recordsPerPage,
    };
    const [currentPage, setCurrentPage] = useState(1);
    const formRef = useRef(null);
    const [filters, setFilters, resetFilters] = usePersistentFilters("testsFilters", defaultFilters);
    const [showFilter, setShowFilter] = useState(false);
    const [numberOfUserdFilters, setNumberOfUserdFilters] = useState();
    const navigate = useNavigate();
    const [tests, setTests] = useState();
    const { useTestsByProfessorMutation, useExportStudentTestsMutation } = studentsManagement;
    const [testsList, { isLoading }] = useTestsByProfessorMutation();
    const [exportTests] = useExportStudentTestsMutation();
    const [languageProgram, setLanguageProgram] = useState([]);
    const { useProgramListMutation } = languageProgramsManagement;
    const [languageProgramList] = useProgramListMutation();
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();
    const [totalRecords, setTotalRecords] = useState(0);

    const { useLocationListMutation } = locationsManagement;
    const { useLanguageListMutation } = languagesManagement;
    
    const [locationList] = useLocationListMutation();
    const [languageList] = useLanguageListMutation();

    const { useEmployeesListMutation } = employeesManagement;
    const [professorList] = useEmployeesListMutation();
    const [professors, setProfessors] = useState([]);

    const [courseType, setCourseType] = useState([]);
    const { useCourseTypeListMutation } = settingsCallManagement;
    const [courseTypeList] = useCourseTypeListMutation();

    const [locations, setLocations] = useState([]);
    const [languages, setLanguages] = useState([]);

    const [status, setStatus] = useState([]);
    const { useStatusListMutation } = settingsCallManagement;
    const [statusList] = useStatusListMutation();

    const gotoEdit = (studentId, testId) => {
        navigate(`/tests/${testId}/students/${studentId}`);
    };

    const onFilter = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onFiltered = (values) => {
        setFilters({
            ...filters,
            startPage: 0,
            date: values.date,
            professor: values.professor,
            time: values.timeFrom,
            firstName: values.firstName,
            lastName: values.lastName,
            type: values.type,
            courseType: values.courseType,
            language: values.language,
            location: values.location,
            languageProgram: values.languageProgram,
            phoneNumber: values.phoneNumber,
            isCanceled: values.isCanceled,
            status: values.status,
        });
    };

    const openFilter = () => {
        setShowFilter(true);
    };

    const closeFilter = () => {
        setShowFilter(false);
    };

    const onPageChange = (currentPage) => {
        setCurrentPage(currentPage);
        const newStartPage = (currentPage - 1) * recordsPerPage;
        setFilters({
            ...filters,
            startPage: newStartPage,
            limitPage: recordsPerPage,
        });
    };

    const formatDateToDMY = (value) => {

        const parts = value.split("-");

        const year = parts[0];
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);

        return `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}`;
    };

    const onExport = async () => {
        const blob = await exportTests().unwrap();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const today = new Date().toISOString().split('T')[0];
        link.download = `Tests_${today}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    useEffect(() => {
        testsList(filters).then((result) => {
            const tests = result?.data?.records;
            setTests(tests);
            setTotalRecords(result?.data?.totalRecords);
        });
        setNumberOfUserdFilters(getNumberOfUsedFilters(filters));

        languageProgramList().then((result) => {
            setLanguageProgram(prepareSelect(result?.data?.records));
        });

        locationList().then((result) => {
            setLocations(prepareSelect(result?.data?.records));
        });

        languageList().then((result) => {
            setLanguages(prepareSelect(result?.data?.records));
        });

        courseTypeList().then((result) => {
            setCourseType(prepareSelect(result?.data?.records));
        });

        professorList({role: 'ROLE_PROFESSOR,ROLE_DIRECTOR_OF_STUDIES'}).then((result) => {
            let options = [];
            result?.data?.records.map((professor) => {
                options.push(
                    {
                        id: professor.id,
                        name: professor.firstName + ' ' + professor.lastName
                    }
                );
            })
            setProfessors(prepareSelect(options));
        });

        statusList().then((result) => {
            let options = [];
            result?.data?.records.map((status) => {
                options.push({
                    id: status.id,
                    name: status.status,
                });
            });
            setStatus(prepareSelect(options));
        });
    }, [filters, testsList]);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                {(decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.SECRETARY) || decodedToken?.roles.includes(roles.ROLE_DIRECTOR) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES)) && (
                    <>
                        <Button title={t("export")} icon="fa-regular fa-cloud-arrow-down" onClick={onExport}></Button>
                    </>
                )} 
            </TopNavigation>
            <Main>
                <Title>{`${t("students.tests")} (${totalRecords})`}</Title>
                <Breadcrumps>
                    <Link title={t("students.tests")} icon="fa-user-graduate"/>
                    <Link title={t("settings.list")} isActive={true} />
                </Breadcrumps>
                {!isLoading && (
                    <>
                        <List>
                            <ListHeader>
                                <ListMenu>
                                    <ListMenuButton title="Filter" icon="fa-filter" onClick={openFilter} badge={numberOfUserdFilters} />
                                </ListMenu>
                                <ListFilter isVisible={showFilter} onClose={closeFilter} onFilter={onFilter} onResetFilter={resetFilters}>
                                    <Formik
                                        innerRef={formRef}
                                        initialValues={{
                                            date: filters?.date || "",
                                            professor: filters?.professor || "",
                                            timeFrom: filters?.timeFrom || "",
                                            firstName: filters?.firstName || "",
                                            lastName: filters?.lastName || "",
                                            type: filters?.type || "",
                                            courseType: filters?.courseType || "",
                                            language: filters?.language || "",
                                            location: filters?.location || "",
                                            languageProgram: filters?.languageProgram || "",
                                            phoneNumber: filters?.phoneNumber || "",
                                            isCanceled: filters?.isCanceled,
                                            status: filters?.status,
                                        }}
                                        onSubmit={onFiltered}
                                    >
                                        {({ values, handleChange }) => (
                                            <Form>
                                                <Row>
                                                    <Field>
                                                        <DatePicker
                                                            name="date"
                                                            label={t("test.date")}
                                                            value={values.date ?? ""}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <TimePicker
                                                            name="timeFrom"
                                                            label={t("calendar.timeFrom")}
                                                            value={values.timeFrom}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select 
                                                            name="professor" 
                                                            label={t('groups.professor')} 
                                                            onChange={handleChange} 
                                                            options={professors} 
                                                            selectedValue={values.professor} 
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input
                                                            name="firstName"
                                                            label={t("students.firstName")}
                                                            value={values.firstName}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input 
                                                            name="lastName" 
                                                            label={t("students.lastName")} 
                                                            value={values.lastName} 
                                                            onChange={handleChange} 
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input 
                                                            name="phoneNumber" 
                                                            label={t("students.phoneNumber")} 
                                                            value={values.phoneNumber} 
                                                            onChange={handleChange} 
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="type"
                                                            label={t("students.typeName")}
                                                            options={prepareSelect([
                                                                { id: "Testiranje", name: t("Testiranje") },
                                                                { id: "Demo čas", name: t("Demo čas") },
                                                                { id: "Retestiranje", name: t("Retestiranje") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.type}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="courseType"
                                                            label={t("students.contractGroupType")}
                                                            options={courseType}
                                                            onChange={handleChange}
                                                            selectedValue={values.courseType}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select 
                                                            name="location" 
                                                            label={t('groups.location')} 
                                                            onChange={handleChange} 
                                                            options={locations} 
                                                            selectedValue={values.location}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select 
                                                            name="language" 
                                                            label={t('groups.language')} 
                                                            onChange={handleChange} 
                                                            options={languages} 
                                                            selectedValue={values.language} 
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                    <Select 
                                                            name="languageProgram" 
                                                            label={t('test.languageProgram')} 
                                                            onChange={handleChange} 
                                                            options={languageProgram} 
                                                            value={values.languageProgram}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="isCanceled"
                                                            label={t("Otkazan")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.isCanceled}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="status"
                                                            label={t("status")}
                                                            options={status}
                                                            onChange={handleChange}
                                                            selectedValue={values.status}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row> 
                                            </Form>
                                        )}
                                    </Formik>
                                </ListFilter>
                            </ListHeader>
                            <ListBody>
                                <TableHead>
                                    <TableRow>
                                        <TableHeadCell></TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("test.date")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("calendar.timeFrom")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("calendar.professor")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("groups.location")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("groups.fullName")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.phoneNumber")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.grade")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.typeName")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.contractGroupType")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("test.languageName")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("test.languageProgram")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("Status")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("reports.verified")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell></TableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tests?.length > 0 &&
                                        tests?.map((test) => {
                                            return (
                                                <TableRow key={test.id}>
                                                    <TableDataCell>
                                                        <Button icon="fa-regular fa-pen" onClick={() => gotoEdit(test.studentId, test.id)}></Button>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {formatDateToDMY(test.date)}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.timeFrom}
                                                        </span>  
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.professorName}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.locationName}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.firstName + ' ' + test.lastName}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.phoneNumber}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.grade}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.type}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.courseTypeName}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.languageName}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.languageProgramName}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isCanceled ? '#ff0000' : '' }}>
                                                            {test.status}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: test.isVerified ? '#27ae60' : '#ff0000' }}>
                                                            {test.isVerified ? t("groups.hasStartedYes") : t("groups.hasStartedNo")}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell></TableDataCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </ListBody>
                        </List>
                        <Pagination currentPage={currentPage} recordsPerPage={recordsPerPage} totalRecords={totalRecords} onClick={onPageChange} />
                    </>
                )}
            </Main>
        </DefaultLayout>
    );
};

export default TestsForProfessor;
